import { CoreState } from "@core/models";
import { selectCoreState } from "@core/store";
import { createSelector } from "@ngrx/store";

export const selectRouter = createSelector(
  selectCoreState,
  (state: CoreState) => state.router?.state
);
